import "./App.css";
import React from "react";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <div className="row">
          <div className="col-lg">
            <div className="card">
              <h1>Retro Weather App</h1>
              <h2>Today's forecast</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
